module.exports = __webpack_public_path__ + "static/media/note-1.0ff22d61.svg";